/**
 * The OpsAlo rings + dot mark, as an inline SVG rather than a static image.
 * Recolourable via `color`, so it reads correctly on both a dark background
 * and a light one — the old /logo-icon.png asset was baked white-on-transparent
 * for dark mode only, which is why it went invisible anywhere the page went light.
 */
export default function LogoMark({ size = 56, color }: { size?: number; color: string }) {
    return (
      <svg viewBox="0 0 40 40" fill="none" width={size} height={size}>
        <circle cx="20" cy="20" r="10.6" stroke={color} strokeWidth="3.3" strokeDasharray="6.66 1.665" strokeLinecap="butt" />
        <circle cx="20" cy="20" r="4.6" fill="#E8A020" />
      </svg>
    );
  }